import M$plugin$SimpleAttributions from './/facade/js/simpleattributions';
import M$control$SimpleAttributionsControl from './/facade/js/simpleattributionscontrol';
import M$impl$control$SimpleAttributionsControl from './/impl/ol/js/simpleattributionscontrol';

if (!window.M.plugin) window.M.plugin = {};
if (!window.M.control) window.M.control = {};
if (!window.M.impl) window.M.impl = {};
if (!window.M.impl.control) window.M.impl.control = {};
window.M.plugin.SimpleAttributions = M$plugin$SimpleAttributions;
window.M.control.SimpleAttributionsControl = M$control$SimpleAttributionsControl;
window.M.impl.control.SimpleAttributionsControl = M$impl$control$SimpleAttributionsControl;
